import SwitchInput from 'components/InputField/switchInput';
import React from 'react';


const RenderFieldList = (props) => {
    const {label, fieldName, fieldIsDisabled, fieldType} = props
    const renderField=()=>{
        switch(fieldType){
            case "Switch":
                return <SwitchInput
                // label={label}
                fieldName={fieldName}
                fieldIsDisbale={fieldIsDisabled}
                />
        }
    }
    return <>
        <li className="form-section credit-section">
            <div className="form-field other-section">
                <p className="label">
                    {label}
                </p>
                {renderField()}
            </div>
        </li>
    </>
}
export default RenderFieldList;